import type { ComponentType } from "react";
import { Route, Routes as ReactRouterRoutes } from "react-router-dom";

import appRouteList from "../../../../config/routes";
import ProtectedRoute from "./ProtectedRoute";

export default function Routes() {
  return (
    <ReactRouterRoutes>
      {appRouteList.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          element={
            <ProtectedRoute
              path={route.path}
              key={route.path}
              element={route.element as ComponentType}
              roles={route.roles}
              isMemo={route.isMemo}
              requiresDeal={route.requiresDeal}
            />
          }
        />
      ))}
    </ReactRouterRoutes>
  );
}
